<template>
    <div class="home">
        <div class="block">
            <h1 class="title">Result</h1>

            <div class="columns">
                <div class="column is-1">
                </div>
                <div class="column is-10 border">
                    <div v-if="job" class="columns">
                        <div class="column is-4 name">Status</div>
                        <div class="column is-8 value">{{ job.status }}</div>
                    </div>
                    <div v-if="job" class="columns">
                        <div class="column is-4 name">Targets</div>
                        <div class="column is-8 value scrollbar">
                            <div>{{job.targets.length}} targets</div>
                            {{ job.targets.join(' ') }}
                        </div>
                    </div>
                    <div v-if="job" class="columns">
                        <div class="column is-4 name">Assay Types</div>
                        <div class="column is-8 value">{{ job.types.join(' / ') }}</div>
                    </div>
                    <div v-if="job" class="columns">
                        <div class="column is-4 name">Criteria</div>
                        <div class="column is-8 value">
                            <CriteriaTable mode="log" :conc="conc" :criteria="criteria"></CriteriaTable>
                        </div>
                    </div>
                    <div v-if="job" class="columns">
                        <div class="column is-4 name">Attributes</div>
                        <div class="column is-8 value">{{ attributes.join(' / ') }}</div>
                    </div>
                    <div v-if="job" class="columns">
                        <div class="column is-4 name">Negative Sample Ratio</div>
                        <div class="column is-8 value">Positive:Negative = 1:{{ job.negative_ratio }}</div>
                    </div>
                </div>
                <div class="column is-1">
                </div>
            </div>
            <div v-if="job && job.status == 'complete'" class="col-sm-12">
                <button @click="download">Download</button>
            </div>
        </div>
    </div>


</template>

<script>
// @ is an alias to /src
import CriteriaTable from "@/components/CriteriaTable";

export default {
    name: 'Result',
    components: {
        CriteriaTable,
    },
    data: function() {
        return {
            job_id: this.$route.params.id,
            job: null,
            conc: [0, 0],
            criteria: [0, 0],
            attributes: [],
            attributesNames: {
                fp2: 'FP2',
                ecfp4: 'ECFP4',
                ecfp6: 'ECFP2',
                maccs: 'MACCS Keys',
                pssm: 'PSSM',
            },
        }
    },
    mounted() {
            const self = this;
            this.$axios.get(this.$api_base + '/api/generate/' + this.job_id).then(function(response) {
                self.job = response.data;

                self.criteria = self.job.criteria;
                self.conc = [
                    (Math.pow(10, -1 * self.criteria[1]) * Math.pow(10, 9)).toFixed(2),
                    (Math.pow(10, -1 * self.criteria[0]) * Math.pow(10, 9)).toFixed(2)
                ]

                self.attributes = [];
                for (let i in self.job.attributes) {
                    self.attributes.push(self.attributesNames[self.job.attributes[i]]);
                }
                console.log(self.job.attributes);
                console.log(self.attributes);
            }).catch(function(e) {
                console.log(e);
            });
    },
    methods: {
        download() {
            const self = this;
            this.$axios.get(this.$api_base + '/api/download/' + this.job_id, { responseType: 'blob' }).then(function(response) {
                const blob = new Blob([response.data], { type: 'application/zip' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = self.job_id + ".zip";
                link.click();
                URL.revokeObjectURL(link.href);
            }).catch(function(e) {
                console.log(e);
            });
        },
    }
}
</script>

<style scoped>
.home {
    text-align: center;
}

.block {
    margin: 50px;
}

.name {
    border: solid 1px;
}

.value {
    border: solid 1px;
    overflow-wrap: break-word;
    overflow-y: scroll;
    max-height: 300px;
}

.border {
    border: solid 1px;
}

.scrollbar {
}

.column {
    text-align: left;
}

</style>